import React, { useEffect } from 'react'
import { useResetRecoilState } from 'recoil'

import BranchInfoSection from './BranchInfoSection'
import BranchAddressSection from './BranchAddressSection'
import BranchContactSection from './BranchContactSection'
import { branchFormState } from 'recoils/atoms/branchFormAtom'

import type { BranchAddressLoadingProps } from 'features/Branch'

const BranchForm: React.FC<BranchAddressLoadingProps> = ({
  setAddressLoading,
}: BranchAddressLoadingProps) => {
  const base = 'f-branch__form'
  const resetBranchForm = useResetRecoilState(branchFormState)

  useEffect(() => {
    return () => resetBranchForm()
  }, [])

  return (
    <div className={base}>
      <BranchInfoSection setAddressLoading={setAddressLoading} />
      <BranchAddressSection setAddressLoading={setAddressLoading} />
      <BranchContactSection />
    </div>
  )
}

export default BranchForm
